<template>
  <div class="company-details-body-text">
    <b-container v-if="selectedCompanyLoading">
      <h2>Tisztelt Ügyfelünk!</h2>
      <p>
        Amennyiben a regisztrációs folyamat közben hibát észlel, kérjük szíveskedjen az info@mgfu.hu e-mail címre
        megküldeni a regisztrációs adatokat, valamint a profiloz hozzárendelni kívánt vállalkozás adatait (Cégnév,
        adószám).
      </p>
      <h4>Megértését köszönjük!</h4>
    </b-container>
    <b-container v-else-if="!companyTerminated">
      <div>
        <h1 class="text-left mt-2" v-if="selectedCompany.short_name[0]">
          {{ selectedCompany.short_name[0].name }}
        </h1>

        <h1 class="text-left mt-2" v-if="selectedCompany.long_name[0] && !selectedCompany.short_name[0]">
          {{ selectedCompany.long_name[0].name }}
        </h1>

        <b-row class="mb-5 mt-4 align-items-center">
          <b-col sm="12" md="6" lg="6" xl="4">
            <div class="text-left">
              Ellenőrizze vállalkozása adatait, majd kattintson a tovább gombra a lehetőségekért!
            </div>
          </b-col>
          <b-col sm="12" md="6" lg="6" xl="4">
            <button type="button" name="button" class="btn btn-primary" @click="nextPage">
              Tovább
            </button>
          </b-col>
        </b-row>
        <b-row>
          <company-details-table :selectedCompany="selectedCompany"></company-details-table>
        </b-row>
        <company-details-chart :selectedCompany="selectedCompany"></company-details-chart>
        <b-row>
          <b-col sm="12" md="6" lg="6" xl="4">
            <div class="mt-5 text-left">
              Ellenőrizze vállalkozása adatait, majd kattintson a tovább gombra a lehetőségekért!
            </div>
          </b-col>
          <b-col sm="12" md="6" lg="6" xl="4">
            <button type="button" name="button" class="btn btn-primary mt-5 mb-5" @click="nextPage">
              Tovább
            </button>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <b-container v-else>
      <b-row>
        <b-col class="col-12 col-lg-6 text-left">
          <h1 class="mb-4">
            Nem tudunk lehetőséget felkínálni
          </h1>
          <h2 class="mb-5">
            A cége kényszertörlési-, felszámolási-, vagy végelszámolási eljárás alatt van, így sajnos nem tudunk
            lehetőségeket felkínálni.
          </h2>
          <b-button variant="primary" class="mb-4" @click="goToHome">Vissza a főoldalra</b-button>
        </b-col>
        <b-col class="col-6 d-none d-lg-flex">
          <termination-svg class="img-fluid"></termination-svg>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import TerminationSvg from '@/components/svg/Termination.vue'
import CompanyDetailsTable from '../components/CompanyDetailsTable.vue'
import CompanyDetailsChart from '../components/CompanyDetailsChart.vue'

export default {
  name: 'CompanyDetails',
  props: {
    flowSource: String
  },
  components: {
    TerminationSvg,
    CompanyDetailsTable,
    CompanyDetailsChart
  },
  data() {
    return {
      userAssignedCompany: null,
      companyConnectedToUser: false
    }
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'selectedCompany',
      'userCompanies',
      'companyTerminated',
      'selectedCompanyLoading'
    ])
  },
  methods: {
    goToHome() {
      this.$router.push('/')
    },
    async nextPage() {
      if (!this.isAuthenticated)
        this.$router.push({ path: 'company-offers', query: { companyId: this.selectedCompany.flaggerId } })
      else {
        await this.$store.dispatch('getUserCompanies', {})

        const companyAssignedToUser = this.userCompanies.filter(
          userCompany => userCompany.companyId === this.selectedCompany.flaggerId
        )

        if (companyAssignedToUser[0]) {
          this.$router.push({ path: 'company-offers-private', query: { companyId: this.selectedCompany.flaggerId } })
        } else {
          this.$router.push({ path: 'add-company-private', query: { companyId: this.selectedCompany.flaggerId } })
        }
      }
    }
  },
  async mounted() {
    if (!this.selectedCompany) {
      if (this.$route.query.companyId == null) {
        if (this.isAuthenticated) this.$router.push('/home')
        else this.$push('/')
        return
      }

      this.$gtag.event('company_details', {
        event_category: 'user_interaction',
        companyId: this.$route.query.companyId
      })

      const getCompanyQueryParams = { value: this.$route.query.companyId }
      await this.$store.dispatch('getCompany', getCompanyQueryParams)
    }
  }
}
</script>

<style scoped>
.company-details-body-text {
  color: var(--color-gray-04) !important;
}

button {
  width: 250px;
  height: 48px;
  font-weight: bold;
}

@media (max-width: 993px) {
  .btn-primary {
    width: 100%;
    margin-top: 30px !important;
    margin-bottom: 15px !important;
  }
}
</style>
